<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="pt-6">
          <span class="headline">Empresa</span>
        </v-card-title>
        <v-card-text class="pb-0 px-3">
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="fCnpj"
                  label="CNPJ"
                  required
                  :readonly="loading"
                  maxlength="18"
                  :autofocus="cnpj === ''"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="senha"
                  label="Senha"
                  :readonly="loading"
                  :autofocus="cnpj !== ''"
                  type="password"
                  v-on:keydown.enter.prevent="login"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-6">
          <label class="red--text">{{ error }}</label>
          <v-spacer></v-spacer>
          <v-btn
            class="px-4"
            color="primary"
            depressed
            :loading="loading"
            :disabled="loading || senha === '' || cnpj === ''"
            @click="login"
            >Login</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from "../api/index.js";
import mask from "br-masks";

export default {
  data: function() {
    return { dialog: false, loading: false, cnpj: "", senha: "", error: "" };
  },
  computed: {
    fCnpj: {
      get: function() {
        return this.cnpj;
      },
      set: function(newValue) {
        this.cnpj = mask.cnpj(newValue.replace(/\D+/g, ""));
      }
    }
  },
  created: function() {
    this.cnpj = mask.cnpj(
      (localStorage.getItem("cnpj") || "").replace(/\D+/g, "")
    );
    this.senha = localStorage.getItem("senha") || "";

    if (this.senha && this.cnpj) {
      this.login();
    } else {
      this.senha = "";
      this.dialog = true;
      localStorage.removeItem("senha");
    }
  },
  methods: {
    login() {
      this.loading = true;
      console.log(this.cnpj, this.senha);
      api.login(
        this.cnpj,
        this.senha,
        data => {
          localStorage.setItem("nome", data.nome);
          localStorage.setItem("senha", this.senha);
          localStorage.setItem("cnpj", data.id);
          this.$store.commit("setLoginData", {
            id: data.id,
            cnpj: mask.cnpj(this.cnpj.replace(/\D+/g, "")),
            senha: this.senha,
            nome: data.nome
          });
          this.dialog = false;
          this.loading = true;
          this.$router.push("/", () => {}); // eslint-disable-line
        },
        error => {
          if (error.response && error.statusCode === 401) {
            localStorage.removeItem("senha");
          }
          this.error =
            (error.response && error.response.data.message) || error.statusText;
          this.senha = "";
          this.loading = false;
          this.dialog = true;
          setTimeout(() => {
            this.error = "";
          }, 3000);
        }
      );
    }
  }
};
</script>

<style></style>
